// Global Types
import type {
  $Translate,
} from 'common.language';

// Global Components
import * as React from 'react';
import {
  FacebookShareButton,
} from 'react-share';

// Helpers
import {
  getLocation,
} from '../../../helpers';

// Types
type $OptionalProps = {
  hash?: null | string;
};

type $Props = $OptionalProps & $Translate;

function ShareButtonView({
  hash,
  t,
}: $Props) {
  let {
    url,
  } = getLocation();

  if (hash) {
    url = `${url}#${hash}`;
  }

  return (
    <FacebookShareButton
      className={'btn btn_primary btn_outlined uppercase px-2 py-1'}
      hashtag={hash as string}
      resetButtonStyle={false}
      title={t('Share')}
      url={url}
    >
      <em className={'la la-facebook text-2xl'} />
    </FacebookShareButton>
  );
}

ShareButtonView.defaultProps = {
  hash: undefined,
};

export default ShareButtonView;
